import { BehaviorSubject } from 'rxjs';
import { useBehaviorSubjectValue } from '@sas-dvr/internal-va-react-core/config/utils';

export const rootClassName$ = new BehaviorSubject<string | undefined>(undefined);

export function setRootClassName(className: string) {
  rootClassName$.next(className);
}

export function getRootClassName() {
  return rootClassName$.value;
}

export function useRootClassName() {
  return useBehaviorSubjectValue(rootClassName$);
}
